import React from "react";
import { Menu } from "antd";
import { useNavigate } from "react-router-dom";
import {
  CheckCircleFilled,
  ExclamationCircleFilled,
  MinusCircleOutlined,
} from "@ant-design/icons";

const AddServer = () => {
  const navigate = useNavigate();

  const handleMenuClick = (key) => {
    navigate(`/addservers/${key}`);
  };

  const handleBack = () => {
    navigate("/servers");
  };

  const topItems = [
    {
      key: "type",
      label: "Type",
      icon: <ExclamationCircleFilled style={{ color: "#4f57f6" }} />,
      status: "warning",
    },
    {
      key: "location",
      label: "Helsinki",
      sub: "Location",
      icon: <CheckCircleFilled style={{ color: "#4f57f6" }} />,
      status: "selected",
    },
    {
      key: "image",
      label: "Ubuntu 24.04",
      sub: "Image",
      icon: <CheckCircleFilled style={{ color: "#4f57f6" }} />,
      status: "selected",
    },
    {
      key: "network",
      label: "IPv4, IPv6",
      sub: "Networking",
      icon: <CheckCircleFilled style={{ color: "#4f57f6" }} />,
      status: "selected",
    },
    {
      key: "ssh",
      label: "SSH keys",
      icon: <ExclamationCircleFilled style={{ color: "#4f57f6" }} />,
      status: "warning",
    },
  ];

  const bottomItems = [
    "Volumes",
    "Firewalls",
    "Backups",
    "Placement groups",
    "Labels",
    "Cloud config",
    "Name",
  ].map((item) => ({
    key: item.toLowerCase(),
    label: item,
    icon: <MinusCircleOutlined style={{ color: "#4f57f6" }} />,
    status: "normal",
  }));

  // UPDATED: Added onClick to navigate for each menu item
  const renderItem = (item) => (
    <Menu.Item
      key={item.key}
      onClick={() => handleMenuClick(item.key)}   // ← added navigation
      icon={item.icon}
      style={{
        paddingLeft: 20,
        fontSize: 14,
        lineHeight: "18px",
        height: "auto",
        paddingTop: 6,
        paddingBottom: 6,
        color:
          item.status === "selected"
            ? "#4f57f6"
            : item.status === "warning"
            ? "#4f57f6"
            : "#4f57f6",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span>{item.label}</span>
        {item.sub && (
          <span style={{ fontSize: 11, color: "#2B2B2B", marginTop: 2 }}>
            {item.sub}
          </span>
        )}
      </div>
    </Menu.Item>
  );

  return (
    <div
      style={{
        width: 300,
        height: "calc(100vh - 48px)",
        background: "#fff",
        color:'#4f57f6',
        paddingTop: 20,
        overflowY: "auto",
        borderLeft: "1px solid #fff",
        position: "fixed",
        right: 0,
        top: "48px",
        zIndex: 1000,
      }}
    >
      {/* RIGHT SIDEBAR MENU */}
      <Menu
        mode="inline"
        style={{
          background: "transparent",
          color: "#fff",
          borderRight: "none",
          paddingRight: 10,
        }}
      >
        {topItems.map(renderItem)}

        <div
          style={{
           // borderTop: "1px solid #333",
            margin: "8px 0 4px",
          }}
        />

        {bottomItems.map(renderItem)}
      </Menu>

      {/* BOTTOM SECTION */}
      <div
        style={{
          marginTop: 40,
          padding: 20,
          color: "#fff",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 20,
            marginBottom: 10,
          }}
        >
          <button
            style={{
              width: 40,
              height: 40,
              fontSize: 20,
              background: "#4f57f6",
              border: "none",
              color: "#fff",
              borderRadius: 5,
            }}
          >
            -
          </button>

          <span style={{ fontSize: 16,color:'#4f57f6', }}>1 Server</span>

          <button
            style={{
              width: 40,
              height: 40,
              fontSize: 20,
              background: "#4f57f6",
              border: "none",
              color: "#fff",
              borderRadius: 5,
            }}
          >
            +
          </button>
        </div>

        <h3 style={{ color: "#2B2B2B" }}>TOTAL</h3>
        <h2 style={{ color: "#06B87D" }}>$0.00/mo</h2>

        <button
          style={{
            marginTop: 10,
            width: 220,
            height: 50,
            background: "#4f57f6",
            border: "1px solid #dfe1ff",
            color: "#fff",
            borderRadius: 8,
            fontSize: 16,
          }}
        >
          Create & Buy now
        </button>
      </div>
    </div>
  );
};

export default AddServer;
